import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import logo_white from '../../assets/images/logo_white.png';

const MySwal = withReactContent(Swal);

const successColor = '#1b8dffff';
const errorColor = '#d32f2f';

const textButton = 'Continuar';
const textButtonError = 'Cerrar';

const successTitle = '¡Bienvenido!';
const errorTitle = '¡Error!';

const successText = 'Estás ingresando al CRM de libranzas.';
const errorText = 'Error al iniciar sesión. Por favor, verifica tus credenciales.';

export const LoginAlert = (color, icon, title, text) => {
  MySwal.fire({
    title: '',
    showConfirmButton: false,
    html: (
      <div className="custom-split-modal">
        <div className="left-half">
          <img src={logo_white} alt="Logo" className="brand-logo" />
        </div>
        <div className="right-half">
          <h2>{title}</h2>
          <p>{text}.</p>
          <button
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            type="button"
            className="continue-btn"
            onClick={() => {

              if (color === successColor) {
                MySwal.close();
                window.location.href = '/dashboard';
              }

              if (color === errorColor) {
                MySwal.close();
              }
            }}

          >

            {color === successColor ? textButton : textButtonError}

          </button>
        </div>
      </div >
    ),
    padding: 0,
    background: 'transparent',
    backdrop: 'rgba(0,0,0,0.8)',
    customClass: {
      popup: 'split-modal-popup',
    },
    didOpen: () => {
      const style = document.createElement('style');
      style.textContent = `
        .split-modal-popup {
          max-width: 900px !important;
          width: 900px !important;
          border-radius: 20px !important;
          overflow: hidden;
          box-shadow: 0 20px 60px rgba(0,0,0,0.3) !important;
          background: transparent !important;
        }

        .custom-split-modal {
          display: flex;
          height: 500px;
          font-family: 'Roboto', sans-serif;
          border-radius: 20px;
          overflow: hidden;
        }

        .left-half {
          flex: 1;
          background: linear-gradient(135deg, ${color} 0%, #0069d1ff 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px;
        }

        .brand-logo {
          width: 80%;
          max-width: 300px;
          filter: drop-shadow(0 10px 20px rgba(0,0,0,0.3));
        }

        .right-half {
          flex: 1;
          background: white;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 60px;
          color: #333;
        }

        .right-half h2 {
          font-size: 2.2rem;
          font-weight: 700;
          margin: 0 0 16px 0;
          color: #1976d2;
        }

        .right-half p {
          font-size: 1.1rem;
          line-height: 1.6;
          color: #555;
          margin: 0 0 30px 0;
        }

        .continue-btn {
          align-self: center;
          color: white;
          background-color: ${color};
          border: none;
          border-radius: 50px;
          padding: 12px 32px;
          font-weight: 600;
          box-shadow: 0 8px 25px rgba(25, 118, 210, 0.4);
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .continue-btn:hover {
          background-color: ;
          transform: translateY(-2px);
        }
      `;
      document.head.appendChild(style);
    },
  });
};

export const LoginErrorAlert = (errorColor,  errorText) => {
  LoginAlert(errorColor, 'error', errorTitle, errorText);
};

export const LoginSuccessAlert = () => {
  LoginAlert(successColor, 'success', successTitle, successText);
};